import { AnyAction } from 'redux';
import {
    LOAD_FREELANCERS_PAYROLL,
    LOADED_FREELANCERS_PAYROLL_SUCCESS,
    LOADED_FREELANCERS_PAYROLL_ERROR,
} from '../actions/Payroll';
import { TApiMeta } from '../types/api';
import { TPayrollFreelancer } from '../components/payments/payroll/types';

export interface PayrollState {
    fetching: boolean;
    error: string | undefined;
    content: TPayrollFreelancer[];
    meta: TApiMeta | undefined;
    requestKey?: string;
}

const initialState: PayrollState = {
    fetching: false,
    error: undefined,
    content: [],
    meta: undefined,
    requestKey: undefined,
};

const reducer = (state = initialState, action: AnyAction): PayrollState => {
    switch (action.type) {
        case LOAD_FREELANCERS_PAYROLL:
            return {
                ...state,
                error: undefined,
                fetching: true,
                requestKey: action.meta?.requestKey,
            };
        case LOADED_FREELANCERS_PAYROLL_SUCCESS:
            if (action.meta?.requestKey !== state.requestKey) {
                return state;
            }
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        case LOADED_FREELANCERS_PAYROLL_ERROR:
            if (action.meta?.requestKey !== state.requestKey) {
                return state;
            }
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        default:
            return state;
    }
};

export default reducer;

